<template>
  <div :class="classes">
    <div
      v-for="(item, index) in items"
      :key="index"
      :class="$style.item"
      :style="item"
    />
  </div>
</template>

<script lang="ts" setup>
import { type StyleValue, useCssModule, computed } from 'vue'
import type { Theme } from './../consts'

defineOptions({
  name: 'UiSkeleton'
})

const props = withDefaults(
  defineProps<{
    items?: StyleValue[]
    theme?: Theme
  }>(),
  {
    items: () => [],
    theme: 'default'
  }
)

const cssModule = useCssModule()

const classes = computed(() => [
  cssModule.skeleton,
  cssModule['theme-' + props.theme]
])
</script>

<style lang="scss" module>
@use './../theme';

.skeleton {
  cursor: wait;
  display: flex;
  gap: 0.8em;
  flex-wrap: wrap;
}

@keyframes translate-x {
  to {
    transform: translateX(100%);
  }
}

.item {
  background: var-default(--skeleton-item-bg);
  overflow: hidden;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    transform: translateX(-100%);
    background: linear-gradient(
      to right,
      transparent,
      hsla(0deg, 0%, 100%, 0.3),
      transparent
    );
    animation: translate-x var(--root-skeleton-item-animation-duration) infinite;
  }
}
</style>
